import { Controller }  from '@hotwired/stimulus'

// Offer Request Categories Controller
//
// This controller manages the visibility and state of category selectors
// based on the selection of their parent categories in the offer request form.
export default class extends Controller {
  static classes = ['hidden']
  static targets = ['radioButton', 'rootSelector', 'subcategory', 'undercategorySelector', 'undercategoryTitle']

  connect() {
    // Show root selector based on radio button selection on page load
    this.radioButtonTargets.forEach(radio => {
      if (radio.checked) {
        const rootSelector = this.rootSelectorTargets.find(rootSelector => {
          return rootSelector.dataset.id == radio.value
        })
        this.showAndEnableSelector(rootSelector)

        // Show and enable undercategory selectors if any subcategory is checked
        this.showUndercategorySelectors()
      }
    })
  }

  showUndercategorySelectors () {
    const checkedRadio = this.radioButtonTargets.find(radio => radio.checked)
    if (!checkedRadio) return

    const currentRootId = checkedRadio.value

    const checkedSubcategories = this.subcategoryTargets.filter(subcategory => {
      return subcategory.checked && subcategory.dataset.parentId == currentRootId
    })

    // Show Undercategory selectors if any subcategory is checked
    checkedSubcategories.forEach(checkedSubcategory => {
      const undercategorySelector = this.undercategorySelectorTargets.find(undercategorySelector => {
        return undercategorySelector.dataset.id == checkedSubcategory.value
      })
      this.showAndEnableSelector(undercategorySelector)
      this.toggleUndercategoryTitle()
    })
  }

  toggleChildCheckboxes (event) {
    const subcategoryId = event.params.id
    const isChecked = event.target.checked
    const undercategorySelectors = this.undercategorySelectorTargets

    undercategorySelectors.forEach(selector => {
      if (selector.dataset.id == subcategoryId) {
        if (isChecked) {
          this.showAndEnableSelector(selector)
        } else {
          this.hideAndDisableSelector(selector)
        }
      }
    })

    // Check state of all child checkboxes
    this.toggleUndercategoryTitle()
  }

  toggleParentCheckboxes (event) {
    const parentId = event.params.id
    const rootSelectors = this.rootSelectorTargets

    // Hide all undercategory selectors
    this.undercategorySelectorTargets.forEach(selector => {
      this.hideAndDisableSelector(selector)
    })

    rootSelectors.forEach(rootSelector => {
      if (rootSelector.dataset.id == parentId) {
        this.showAndEnableSelector(rootSelector)

        // Show and enable undercategory selectors if any subcategory is checked
        this.showUndercategorySelectors()
      } else {
        this.hideAndDisableSelector(rootSelector)
      }
    })
  }

  toggleUndercategoryTitle () {
    const checkedSubcategories = this.subcategoryTargets.filter(subcategory => subcategory.checked)

    // Check if any of the checked subcategories have children to show
    const hasVisibleChildren = checkedSubcategories.some(checkedSubcategory => {
      return this.undercategorySelectorTargets.some(undercategorySelector => {
        return undercategorySelector.dataset.parentId == checkedSubcategory.value
      })
    })

    if (hasVisibleChildren) {
      this.undercategoryTitleTarget.classList.remove(this.hiddenClass)
    } else {
      this.undercategoryTitleTarget.classList.add(this.hiddenClass)
    }
  }

  showAndEnableSelector (selector) {
    if (!selector) return

    selector.classList.remove(this.hiddenClass)
    let checkboxes = selector.querySelectorAll("input[type=checkbox]")
    this.enableCheckboxes(checkboxes)
  }

  hideAndDisableSelector (selector) {
    selector.classList.add(this.hiddenClass)
    let checkboxes = selector.querySelectorAll("input[type=checkbox]")
    this.disableCheckboxes(checkboxes)
  }

  disableCheckboxes(checkboxes) {
    checkboxes.forEach(checkbox => {
      checkbox.disabled = true
    })
  }

  enableCheckboxes(checkboxes) {
    checkboxes.forEach(checkbox => {
      checkbox.disabled = false
    })
  }
}
